import { fun_PostAction } from "@/api";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      searchFlag:null, // 查询标记
      // 查询表单绑定值
      form: {
        prjbuildCorpName: null, // 招标人名称
        prjName: null, // 工程名称
        prjLargeClass: null, // 工程类别
        regulators: null, // 行政监督部门
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "招标人名称：",
          value: "prjbuildCorpName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请输入",
          clearable: true,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "招标项目名称",
          prop: "prjName",
          isShow: true,
          fixed: true,
          width: "280",
        },
        {
          label: "状态",
          slotName: "state",
          fixed: true,
          width: "100",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          width: "250",
        },
        {
          label: "招标人名称",
          prop: "prjbuildCorpName",
          width: "220",
        },
        {
          label: "招标人信用代码",
          prop: "buildCorpNameCode",
          width: "200",
        },
        {
          label: "招标代理单位名称",
          prop: "agencyCorpName",
          width: "220",
        },
        {
          label: "招标代理单位社会信用代码",
          prop: "agencyCorpCode",
          width: "220",
        },
        {
          label: "代理机构法人姓名",
          prop: "agencyCorpLegalPerson",
          width: "150",
        },
        {
          label: "代理机构技术负责人姓名",
          prop: "agencyCorpTechMan",
          width: "200",
        },
        {
          label: "项目负责人姓名",
          prop: "prjManName",
          width: "150",
        },
        {
          label: "项目负责人职务",
          prop: "prjManDuty",
          width: "150",
        },
        {
          label: "项目负责人职称",
          prop: "prjManTitle",
          width: "150",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    }
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/agencyCorpRecords/agencyCorpRecordsChooseList", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 代理备案选择选择
     */
    fun_AgencyCorpRecordsSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 调用返回赋值方法
        this.$parent.fun_AgencyCorpRecordsSelected(e);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}